module.exports = __webpack_public_path__ + "img/mingShi_en.76f42779.png";